import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetDashboardChartData } from 'domain/usecases'; // You'll need to create this interface
import { RemoteGetDashboardChartData } from 'data/usecases'; // You'll need to create this class

export const makeRemoteGetDashboardChartData = (): GetDashboardChartData => {
  return new RemoteGetDashboardChartData(makeApiUrl('/dashboard/chartData'), makeAuthorizeHttpClientDecorator());
};
